import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { TeamTransferDialogComponent } from './team-transfer-dialog.component';

@NgModule({
  declarations: [TeamTransferDialogComponent],
  imports: [CommonModule, MaterialModule, SharedModule, ReactiveFormsModule],
  exports: [TeamTransferDialogComponent],
  entryComponents: [TeamTransferDialogComponent],
})
export class TeamTransferDialogModule {}
